































import Vue, { PropType } from "vue";

import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { CashCountViewType } from "@/model/data/dashboard/CashCountViewType";
import { BinCountType } from "@/model/data/dashboard/BinCountType";

export default Vue.extend({
    data() {
        return {
            BinCountType,
        };
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    computed: {
        availableCashCountViewType() {
            return [
                {
                    value: CashCountViewType.DistributionCount,
                    text: this.$t("dashboard.widget_cash_count.view_type.distribution_count"),
                },
                {
                    value: CashCountViewType.DistributionPercentage,
                    text: this.$t("dashboard.widget_cash_count.view_type.distribution_percentage"),
                },
                {
                    value: CashCountViewType.DistributionValue,
                    text: this.$t("dashboard.widget_cash_count.view_type.distribution_value"),
                },
                {
                    value: CashCountViewType.TotalValue,
                    text: this.$t("dashboard.widget_cash_count.view_type.total_value"),
                },
            ];
        },
        availableBinType() {
            return [
                {
                    value: BinCountType.ByBinCount,
                    text: this.$t("dashboard.widget_cash_count.bin_configuration.by_bin_count"),
                },
                {
                    value: BinCountType.ByBinSize,
                    text: this.$t("dashboard.widget_cash_count.bin_configuration.by_bin_size"),
                },
            ];
        },
        availableBinCount() {
            switch ((this.widget as DashboardWidget).viewConfig.cashCountViewType) {
                case CashCountViewType.DistributionPercentage: // percentage
                    return [2, 5, 10, 20];
                case CashCountViewType.DistributionCount: // count
                    return [2, 5, 10, 20];
                case CashCountViewType.DistributionValue: // value
                    return [2, 5, 10, 20];
                default:
                    return [];
            }
        },
        availableBinSize() {
            switch ((this.widget as DashboardWidget).viewConfig.cashCountViewType) {
                case CashCountViewType.DistributionPercentage: // percentage
                    return [2, 5, 10, 20];
                case CashCountViewType.DistributionCount: // count
                    return [50, 100, 1000, 5000];
                case CashCountViewType.DistributionValue: // value
                    return [1000, 2000, 5000, 10000];
                default:
                    return [];
            }
        },
    },
});
